import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useFormik } from 'formik';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Divider } from '@mui/material';

export const getQuestionsInitialValues = ({ questions }) => {
    const questionArray = {};

    if (!questions) {
        return null
    }

    // Iterate each key in questions array
    questions.forEach(question => {
        questionArray[question.name] = {
            'question': question.question,
            'answer': null
        };
    })

    return questionArray;
}

const FirmographicQuestionsForm = forwardRef(({ respondentId, firmographic, formActions, onSubmit }, ref) => {
    const [numberOfAnswers, setNumberOfAnswers] = useState(0);

    const validate = (values) => {
        const errors = {};
        // if (!values.name) {
        //     errors.name = 'Name is required';
        // }
        return errors;
    }

    const initialValues = {
        id: firmographic.id,
        respondent_id: respondentId || '',
        questions: getQuestionsInitialValues(firmographic)
    }

    const handleChange = (event, question) => {
        if (!formik.values.questions[question.name].answer) {
            setNumberOfAnswers(numberOfAnswers + 1)
        }
        formik.setFieldValue(`questions.${question.name}.answer`, event.target.value)
    }

    const formik = useFormik({
        initialValues: initialValues,
        validate: validate,
        onSubmit: onSubmit,
    });

    useImperativeHandle(ref, () => ({
        resetForm() {
            formik.handleReset()
        },
    }));

    const renderQuestion = (question) => {
        return (
            <Box key={question.id} sx={{ ml: 2, mt: 2, mb: 5 }}>
                <Stack direction="column" >
                    <Typography variant="h6" sx={{ color: "green" }}>
                        {question.question}
                    </Typography>
                    <Box>
                        <FormControl>
                            <RadioGroup
                                row={true}
                            >
                                {question.options.map((option) => {
                                    return (
                                        <FormControlLabel
                                            key={option}
                                            value={option}
                                            onChange={(event) => handleChange(event, question)}
                                            control={<Radio />}
                                            label={option}
                                            sx={{ fontSize: 5 }}
                                        />
                                    )
                                })}
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Stack>
            </Box>
        )
    }

    return (
        <Box
            component="form"
            onSubmit={formik.handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%', // Ensures the form respects the parent height
                p: 2
            }}
        >
            <Typography variant="body" sx={{ mb: 3 }}>
                Welcome! Before we start, please answer these {firmographic.questions.length} questions.
            </Typography>
            <Divider />

            {/* Scrollable container */}
            <Box
                sx={{
                    flex: 1, // Takes up the remaining space in the parent container
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    minHeight: 0, // Prevents overflow due to flex
                }}
            >
                <Stack direction="column">
                    {firmographic.questions.map((question) => {
                        return renderQuestion(question);
                    })}
                </Stack>
            </Box>

            <Divider />
            <Stack direction="row" alignItems="center" gap={2}>
                <Typography sx={{ mt: 2 }}>
                    Answered {numberOfAnswers} of {firmographic.questions.length} questions
                </Typography>

                {/* Action Buttons */}
                {numberOfAnswers === firmographic.questions.length ?
                    <Box>
                        {formActions()}
                    </Box>
                    : null}
            </Stack>
        </Box>
    )
})

export default FirmographicQuestionsForm
